import React, { useState } from 'react';
import {
  Box,
  Typography,
  useMediaQuery,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StepButtonBar } from './StepButtonBar';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';

const PRIMARY = '#c4122f';
const outlinedRedBtn: React.CSSProperties = { fontWeight: 700, borderColor: PRIMARY, color: PRIMARY };

interface DeleteStep3ConfirmProps {
  selectedRowsData: any[];
  selectedCompanyUnit: any;
  onConfirmDelete: () => Promise<void>;
  onBack: () => void;
  onCancel: () => void;
  isFirstStep?: boolean;
}

const DeleteStep3Confirm = ({
  selectedRowsData,
  selectedCompanyUnit,
  onConfirmDelete,
  onBack,
  onCancel,
}: DeleteStep3ConfirmProps) => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const paperPadding = isMobile ? theme.spacing(2) : theme.spacing(3);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      await onConfirmDelete();
    } catch (error) {
      console.error('Delete failed:', error);
      setIsDeleting(false);
    }
  };
  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'flex',
          width: '100%',
          gap: '10px',
          flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'stretch',
        }}
      >
        <div
          style={{
            width: '100%',
            flexShrink: 0,
            padding: paperPadding,
            backgroundColor: '#f7f0f1',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
            justifyContent: 'flex-start',
            alignItems: 'stretch',
          }}
        >
          <Typography
            variant="h6"
            style={{
              fontWeight: 600,
              marginBottom: theme.spacing(2),
              lineHeight: 1.4,
              fontSize: isMobile ? '16px' : '18px',
            }}
          >
            {formatMessage(
              { id: 'law-portal.delete-law.confirm-title' },
              { unit: selectedCompanyUnit?.name ?? '' }
            )}
          </Typography>

          <Typography
            variant="body2"
            style={{
              marginBottom: theme.spacing(2),
              color: '#555',
              fontSize: '14px',
            }}
          >
            {formatMessage({ id: 'law-portal.manage.law-list.table.delete.confirmation' })}
          </Typography>

          {/* Law rows — same style as image */}
          <Box style={{ display: 'flex', flexDirection: 'column' }}>
            {selectedRowsData.map((law: any) => (
              <Box
                key={law.id}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                //   backgroundColor: '#fff',
                //   border: `1px solid ${PRIMARY}`,
                //   borderRadius: '6px',
                  padding: '12px 14px',
                }}
              >
                <Box
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    backgroundColor: PRIMARY,
                    borderRadius: '6px',
                    flexShrink: 0,
                  }}
                >
                  <DescriptionOutlinedIcon style={{ color: '#fff', fontSize: '24px' }} />
                </Box>
                <Typography
                  variant="body2"
                  style={{ fontWeight: 500, fontSize: '14px', color: '#222' }}
                >
                  {law?.number} – {law?.name}
                </Typography>
              </Box>
            ))}
          </Box>
        </div>
      </div>

      <Box>
        <StepButtonBar
          onCancel={onCancel}
          onBack={onBack}
          onNext={handleConfirmDelete}
          nextLabel="law-portal.delete-law.confirm-delete"
          nextDisabled={isDeleting}
          isLoading={isDeleting}
          formatMessage={formatMessage}
          showBack={true}
          isDeleteStep={true}
        />
      </Box>
    </div>
  );
};

export default DeleteStep3Confirm;